import { gql } from "@apollo/client";

const NOTE = `
  id
  app
  version
  title
  intro
  items
  published
  publishedAt
  updatedAt
  updatedBy
`;

export const GET_APP_RELEASE_NOTES = gql`
  query GetAppReleaseNotes($app: String) {
    getAppReleaseNotes(app: $app) {
      status
      message
      icons
      actions
      notes { ${NOTE} }
    }
  }
`;

export const SAVE_APP_RELEASE_NOTE = gql`
  mutation SaveAppReleaseNote($data: AdminReleaseNoteInput!) {
    saveAppReleaseNote(data: $data) {
      status
      message
      note { ${NOTE} }
    }
  }
`;

export const DELETE_APP_RELEASE_NOTE = gql`
  mutation DeleteAppReleaseNote($id: ID!) {
    deleteAppReleaseNote(id: $id) {
      status
      message
    }
  }
`;
